<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 16.5725C11.7074 16.5725 11.4149 16.4605 11.192 16.2377L4.33513 9.38076C3.88829 8.93392 3.88829 8.21166 4.33513 7.76482C4.78197 7.31798 5.50423 7.31798 5.95107 7.76482L12 13.8137L18.0489 7.76482C18.4958 7.31798 19.218 7.31798 19.6649 7.76482C20.1117 8.21166 20.1117 8.93392 19.6649 9.38076L12.808 16.2377C12.5851 16.4605 12.2926 16.5725 12 16.5725Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
